import Plotly from 'plotly.js/lib/core';
import heatmap from 'plotly.js/lib/heatmap';
import scatter from 'plotly.js/lib/scatter';
import type { ComponentType, Ref } from 'react';
import type { PlotParams } from 'react-plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';

Plotly.register([heatmap, scatter]);

const Plot = createPlotlyComponent(Plotly) as ComponentType<PlotParams & { ref?: Ref<any> }>;

export default Plot;
